import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class ClauseService {
    static getDependentClausesForLob(jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('coverage'), 'getDependentCoveragesForLob', [jobNumber], additionalHeaders);
    }
}
